import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './gallery.css';

const Gallery = ({ id = 'gallery', title, galleries = [] }) => {
  const { t } = useTranslation();

  // Добавляйте новых авторов в этот массив:
  // {
  //   author: 'Имя автора',
  //   photos: ['/images/path/photo1.jpg', '/images/path/photo2.jpg']
  // }
  /* Галерея 2025 года сохранена ниже как пример заполнения новых галерей.
  const galleriesByAuthor = [
    {
      author: 'Juri Vsivtsev, Roman Sergeevits:',
      photos: [
        '/images/2025/JuriVsivtsev/1.jpg',
        '/images/2025/JuriVsivtsev/2.jpg',
        '/images/2025/JuriVsivtsev/3.jpg',
        '/images/2025/JuriVsivtsev/4.jpg',
        '/images/2025/JuriVsivtsev/5.jpg',
        '/images/2025/JuriVsivtsev/6.jpg',
        '/images/2025/JuriVsivtsev/7.jpg',
        '/images/2025/JuriVsivtsev/8.jpg',
        '/images/2025/JuriVsivtsev/9.jpg',
        '/images/2025/JuriVsivtsev/10.jpg',
        '/images/2025/JuriVsivtsev/11.jpg',
        '/images/2025/JuriVsivtsev/12.jpg',
        '/images/2025/JuriVsivtsev/13.jpg',
        '/images/2025/JuriVsivtsev/14.jpg',
        '/images/2025/JuriVsivtsev/57.jpg',
        '/images/2025/JuriVsivtsev/15.jpg',
        '/images/2025/JuriVsivtsev/16.jpg',
        '/images/2025/JuriVsivtsev/17.jpg',
        '/images/2025/JuriVsivtsev/18.jpg',
        '/images/2025/JuriVsivtsev/19.jpg',
        '/images/2025/JuriVsivtsev/59.jpg',
        '/images/2025/JuriVsivtsev/20.jpg',
        '/images/2025/JuriVsivtsev/21.jpg',
        '/images/2025/JuriVsivtsev/22.jpg',
        '/images/2025/JuriVsivtsev/60.jpg',
        '/images/2025/JuriVsivtsev/23.jpg',
        '/images/2025/JuriVsivtsev/58.jpg',
        '/images/2025/JuriVsivtsev/24.jpg',
        '/images/2025/JuriVsivtsev/25.jpg',
        '/images/2025/JuriVsivtsev/26.jpg',
        '/images/2025/JuriVsivtsev/27.jpg',
        '/images/2025/JuriVsivtsev/28.jpg',
        '/images/2025/JuriVsivtsev/29.jpg',
        '/images/2025/JuriVsivtsev/30.jpg',
        '/images/2025/JuriVsivtsev/31.jpg',
        '/images/2025/JuriVsivtsev/32.jpg',
        '/images/2025/JuriVsivtsev/33.jpg',
        '/images/2025/JuriVsivtsev/34.jpg',
        '/images/2025/JuriVsivtsev/35.jpg',
        '/images/2025/JuriVsivtsev/36.jpg',
        '/images/2025/JuriVsivtsev/37.jpg',
        '/images/2025/JuriVsivtsev/38.jpg',
        '/images/2025/JuriVsivtsev/39.jpg',
        '/images/2025/JuriVsivtsev/40.jpg',
        '/images/2025/JuriVsivtsev/41.jpg',
        '/images/2025/JuriVsivtsev/42.jpg',
        '/images/2025/JuriVsivtsev/43.jpg',
        '/images/2025/JuriVsivtsev/44.jpg',
        '/images/2025/JuriVsivtsev/45.jpg',
        '/images/2025/JuriVsivtsev/46.jpg',
        '/images/2025/JuriVsivtsev/47.jpg',
        '/images/2025/JuriVsivtsev/48.jpg',
        '/images/2025/JuriVsivtsev/49.jpg',
        '/images/2025/JuriVsivtsev/50.jpg',
        '/images/2025/JuriVsivtsev/51.jpg',
        '/images/2025/JuriVsivtsev/52.jpg',
        '/images/2025/JuriVsivtsev/53.jpg',
        '/images/2025/JuriVsivtsev/54.jpg',
        '/images/2025/JuriVsivtsev/55.jpg',
        '/images/2025/JuriVsivtsev/56.jpg',        
      ],
    },
  ]; */
  const galleriesByAuthor = galleries;

  const [selectedAuthorIndex, setSelectedAuthorIndex] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const selectedGroup = selectedAuthorIndex === null ? null : galleriesByAuthor[selectedAuthorIndex] || null;
  const selectedImage = selectedGroup?.photos[currentImageIndex] || null;

  const openModal = (authorIndex, imageIndex) => {
    setSelectedAuthorIndex(authorIndex);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setSelectedAuthorIndex(null);
    setCurrentImageIndex(0);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    if (!selectedGroup) return;
    const nextIndex = (currentImageIndex + 1) % selectedGroup.photos.length;
    setCurrentImageIndex(nextIndex);
  };

  const goToPrev = (e) => {
    e.stopPropagation();
    if (!selectedGroup) return;
    const prevIndex = (currentImageIndex - 1 + selectedGroup.photos.length) % selectedGroup.photos.length;
    setCurrentImageIndex(prevIndex);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedGroup) return;

      if (e.key === 'ArrowRight') {
        const nextIndex = (currentImageIndex + 1) % selectedGroup.photos.length;
        setCurrentImageIndex(nextIndex);
      }

      if (e.key === 'ArrowLeft') {
        const prevIndex = (currentImageIndex - 1 + selectedGroup.photos.length) % selectedGroup.photos.length;
        setCurrentImageIndex(prevIndex);
      }

      if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedGroup, currentImageIndex]);

  return (
    <section id={id} className="gallery-section">
      <div className="gallery-content">
        <h2 className="gallery-title">{title || t('gallery.title')}</h2>
        {galleriesByAuthor.length === 0 && <p className="gallery-placeholder">{t('gallery.placeholder')}</p>}

        {galleriesByAuthor.map((group, authorIndex) => (
          <div key={`${group.author}-${authorIndex}`} className="gallery-author-block">
            {group.author && <p className="gallery-author-name">{group.author}</p>}
            <div className="gallery-grid">
              {group.photos.map((photo, photoIndex) => (
                <div
                  key={`${photo}-${photoIndex}`}
                  className="gallery-item"
                  onClick={() => openModal(authorIndex, photoIndex)}
                >
                  <img
                    src={photo}
                    alt={t('gallery.photoAlt', { author: group.author, index: photoIndex + 1 })}
                    className="gallery-image"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}

        {selectedImage && (
          <div className="gallery-modal-overlay" onClick={closeModal}>
            <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="gallery-close-modal" onClick={closeModal}>
                &times;
              </button>
              <button className="gallery-nav-button prev" onClick={goToPrev}>
                &lt;
              </button>
              <img
                src={selectedImage}
                alt={t('gallery.photoAlt', {
                  author: selectedGroup?.author || '',
                  index: currentImageIndex + 1,
                })}
                className="gallery-modal-image"
              />
              <button className="gallery-nav-button next" onClick={goToNext}>
                &gt;
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
